import { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useDrawsUpdated } from './useDrawsUpdated';

export const useDigitRepeatAnalysis = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const request = useRef(null);
  const load = useCallback(async () => {
    request.current?.abort();
    const controller = new AbortController();
    request.current = controller;
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/analysis/digit-pattern/repeats`, {
        signal: controller.signal, withCredentials: true, timeout: 30000,
      });
      if (!controller.signal.aborted) { setData(response.data); setError(null); }
    } catch (e) {
      if (!controller.signal.aborted) setError('Digit repeat analysis could not be loaded.');
    } finally {
      if (!controller.signal.aborted) setLoading(false);
    }
  }, []);
  useEffect(() => { load(); return () => request.current?.abort(); }, [load]);
  useDrawsUpdated(load);
  return { data, loading, error, retry: load };
};
